class Care {
    constructor(apiService = null) {
        this.obj_name = 'care';
        this.apiService = apiService; // 將 ApiService 實例儲存為屬性
    }

    // 共用的 API 呼叫方法
    async callApi(method, endpoint, parameter = {}, progressEvent = null) {
        const apiConfig = {
            url: `${this.apiService.url}${this.obj_name}/${endpoint}`,
            parameter,
        };

        return new Promise((resolve) => {
            if (method === 'get') {
                // GET 請求
                apiConfig.url += `?${this.apiService.getMethodEncryp(parameter)}`;
                this.apiService.getApi({
                    url: apiConfig.url,
                    success: resolve,
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            } else if (method === 'post') {
                // POST 請求
                this.apiService.postFormDataApi({
                    url: apiConfig.url,
                    parameter: apiConfig.parameter,
                    success: resolve,
                    progress: (res) => {
                        this.apiService.debug(res);
                        if (progressEvent) {
                            progressEvent(res);
                        }
                    },
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            }
        });
    }

    // 照養 | 101取得照養紀錄
    async getCareRecordByKeywordWithPage(parameter) {
        return this.callApi('get', 'getCareRecordByKeywordWithPage', parameter);
    }

    // 照養 | 102新增照養紀錄
    async addOrUpdCareRecord(parameter, progressEvent = null) {
        return this.callApi('post', 'addOrUpdCareRecord', parameter, progressEvent);
    }

    // 照養 | 103取得照養詳細資料
    async getCareRecord(parameter) {
        return this.callApi('get', 'getCareRecord', parameter);
    }

    // 食譜 | 104新增餵食紀錄
    async addOrUpdCareFeedRecordByJson(parameter, progressEvent = null) {
        return this.callApi('post', 'addOrUpdCareFeedRecordByJson', parameter, progressEvent);
    }

    // 照養 | 104取得餵食詳細資料
    async getCareFeedRecord(parameter) {
        return this.callApi('get', 'getCareFeedRecord', parameter);
    }

    // 照養 | 105取得照養中動物列表
    async getCareRecordByKeyword(parameter) {
        return this.callApi('get', 'getCareRecordByKeyword', parameter);
    }

    // 照養 | 106更新禁食狀態
    async updMedicalIsFastingByMedicalRecordId(parameter, progressEvent = null) {
        return this.callApi('post', 'updMedicalIsFastingByMedicalRecordId', parameter, progressEvent);
    }

    // 照養 | 107當日食譜配料總覽
    async getCurrentRecipeFeedByKeywordWithPage(parameter) {
        return this.callApi('get', 'getCurrentRecipeFeedByKeywordWithPage', parameter);
    }
}

export default Care;
